import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div class="container text-center" className="Weather">
      <h1 class="header"> The Weather, somewhere. </h1>
      <Weather />
      </div>
  );
}

export default App;
